import React, { useEffect, useState, useRef, useCallback } from 'react'
import { BasicResult, EditBasicResultKey } from '../../../../types/models/Presc'
import { useModal } from '../../../../shared'
import { BirthdaySelectModalBody } from '../../../../components/templates/BirthdaySelectModalBody'

export const useBirthdaySelectModal = (
  prescId: string,
  basicResult: BasicResult,
  editBasicResult: (key: EditBasicResultKey) => void
) => {
  // prescIdをキーにして、prescId変更時に初期値を適用
  const [birthdayState, setBirthdayState] = useState<{
    prescId: string
    value: string
  }>({
    prescId: '',
    value: basicResult['id_13_patient_birthday']['selected_option'],
  })

  const birthday =
    prescId === birthdayState.prescId
      ? birthdayState.value
      : basicResult['id_13_patient_birthday']['selected_option']

  const setBirthday = useCallback(
    (value: string) => {
      setBirthdayState({ prescId, value })
    },
    [prescId]
  )

  const closeEditableModalRef = useRef<() => void>(() => {})

  const completeEdit = useCallback(() => {
    editBasicResult({
      key: 'id_13_patient_birthday',
      value: birthday,
    })
    closeEditableModalRef.current()
  }, [editBasicResult, birthday])

  const {
    openModal: openEditableModal,
    closeModal: closeEditableModal,
    renderModal: renderEditableModal,
  } = useModal(
    <BirthdaySelectModalBody
      completeEdit={completeEdit}
      birthday={birthday}
      setBirthday={setBirthday}
    />,
    'right'
  )

  useEffect(() => {
    closeEditableModalRef.current = closeEditableModal
  }, [closeEditableModal])

  return { openEditableModal, renderEditableModal }
}
